module.exports = __webpack_public_path__ + "Server-Unknown.Ftp.fd22cae205811a9113bf906342a26c1e.hashedasset.svg";